export default function (element, data) {
    let prevText = element.value;
    element.addEventListener("input", function () {
        if (prevText.length > 0 && element.value.length < 1) {
            element.style.height = "0px";
        } else {
            element.style.height = element.scrollHeight + "px";
        }

        prevText = element.value;
    });
}

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary